import { render, staticRenderFns } from "./edit-agent.vue?vue&type=template&id=6e19fc34&scoped=true&"
import script from "./edit-agent.vue?vue&type=script&lang=ts&"
export * from "./edit-agent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e19fc34",
  null
  
)

export default component.exports